import type { Location, PreparationLine } from '../models/PreparationModels';

export interface LocationWithAvailableStock {
  id: number;
  code: string;
  stock: number;
}

export const collectLineLocations = (line: PreparationLine): Location[] => {
  const byId = new Map<number, Location>();
  [...(line.suggested_locations ?? []), ...(line.other_locations ?? [])].forEach((loc) => {
    if (loc?.id) byId.set(loc.id, loc);
  });
  return Array.from(byId.values());
};

/** Ubicaciones del producto con stock > 0 distintas a la ubicación del descuadre */
export const getOtherLocationsWithStock = (
  line: PreparationLine,
  discrepancyLocationId: number,
): LocationWithAvailableStock[] => {
  if (!discrepancyLocationId) return [];

  return collectLineLocations(line)
    .filter((loc) => loc.id !== discrepancyLocationId && (loc.stock ?? 0) > 0)
    .map((loc) => ({
      id: loc.id,
      code: loc.code,
      stock: loc.stock,
    }));
};

export const hasStockInOtherLocations = (line: PreparationLine | undefined, discrepancyLocationId: number): boolean => {
  if (!line || !discrepancyLocationId) return false;
  return getOtherLocationsWithStock(line, discrepancyLocationId).length > 0;
};

/** Stock disponible del producto en la ubicación (si está en suggested/other de la línea) */
export const getStockAtLocation = (line: PreparationLine | undefined, locationId: number): number | null => {
  if (!line || !locationId) return null;
  const loc = collectLineLocations(line).find((l) => l.id === locationId);
  if (!loc) return null;
  return loc.stock ?? 0;
};

/** Máximo de uds. del descuadre: stock en ubicación; si no hay dato, pendiente de la línea */
export const getMaxDiscrepancyQty = (
  line: PreparationLine | undefined,
  locationId: number,
  remainingToPick: number,
): number => {
  const stock = getStockAtLocation(line, locationId);
  if (stock !== null) return Math.max(0, stock);
  return Math.max(0, remainingToPick);
};
